import { IInputProps } from 'modules';
import React, { FC, useEffect, useRef } from 'react';

export const InputText: FC<IInputProps> = (props) => {
  const blurTimerRef = useRef<ReturnType<typeof setTimeout>>();

  useEffect(() => {
    return () => {
      if (blurTimerRef.current !== undefined) {
        clearTimeout(blurTimerRef.current);
      }
    };
  }, []);

  const {
    value,
    onChange,
    onTouched,
    onChangeCallback,
    isReadOnly,
    onBlur,
    onFocus,
    placeholder,
    // Filter out custom props that shouldn't go to DOM
    isDisabled,
    isRequired,
    getValue,
    locales,
    isMutilLocale,
    error,
    description,
    label,
    onChangeEvent,
    tabIndex,
    tail,
    trailing,
    limitSize,
    limitWidth,
    limitHeight,
    temp,
    urlExample,
    customTypeAccept,
    decimalScale,
    dateTimeFormat,
    isClear,
    showImage,
    onKeyDown,
    defaultValue, // Add defaultValue to avoid overlap with 'value'
    ...rest
  } = props;

  return (
    <input
      type='text'
      onChange={(e) => {
        if (isDisabled) return;
        onChange(e.target.value);
        onChangeCallback?.(e.target.value);
      }}
      onBlur={() => {
        if (blurTimerRef.current !== undefined) {
          clearTimeout(blurTimerRef.current);
        }
        // Schedule first so cleanup can cancel it if onBlur unmounts the input.
        blurTimerRef.current = setTimeout(() => {
          blurTimerRef.current = undefined;
          onTouched?.();
        }, 500);
        onBlur?.();
      }}
      onFocus={() => {
        if (onFocus) onFocus();
      }}
      onKeyDown={onKeyDown}
      value={value || ''}
      placeholder={placeholder || ''}
      readOnly={isReadOnly}
      disabled={isDisabled || isReadOnly}
      {...rest}
    />
  );
};
